import * as React from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';

export interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function ConfirmationDialog(props: ConfirmationDialogProps & { message?: React.ReactNode, onConfirm: () => void }) {
  const { onClose, open, message, onConfirm, ...other } = props;

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 }, fontFamily: 'inherit' }}
      maxWidth="xs"
      open={open}
      onClose={onClose}
      {...other}
    >
      <DialogTitle sx={{ fontWeight: 'bold', color: 'primary.main', fontSize: '1.5rem' }}>Confirmation required</DialogTitle>
      <DialogContent dividers sx={{ textAlign: 'left', fontSize: '0.875rem' }}>
        {props.message}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} sx={{ textTransform: 'capitalize' }}>Cancel</Button>
        <Button onClick={props.onConfirm} sx={{ textTransform: 'capitalize' }}>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}
